import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import OTGrid from './OTGrid.js'
import OTAbm from './OTAbm.js'
import OTImport from './OTImport.js';
import {FormattedMessage, injectIntl} from 'react-intl';

class OTs extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><i className="la la-briefcase ml-1 mr-1 align-middle"></i><FormattedMessage id="oTs.header_administracion_gerenciadores" defaultMessage="Administración de OTs"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={OTGrid} />
						<Route exact path={`${this.props.match.url}/add`} component={(props) => <OTAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} component={(props) => <OTAbm {...props} action="EDIT" />} />
						<Route exact path={`${this.props.match.url}/:id/import`} component={(props) => <OTImport {...props} action="IMPORT" />} />
						<Route path={`${this.props.match.url}/:id`} component={(props) => <OTAbm {...props} action="VIEW" />} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default injectIntl(OTs);